const formatPhoneNumber = (value, prevValue = '') => {
  // Защита — если value пустое или не строка
  if (!value) return '';
  value = String(value);

  let val = value.replace(/\D/g, ''); // Убираем все нецифровые символы

  if (!val) return '';

  if (val.startsWith('8')) {
    val = '7' + val.slice(1);
  }

  if (val.length < 11 && !val.startsWith('7')) {
    val = '7' + val;
  }

  if (prevValue.length > value.length) {
    return value;
  }

  if (val.startsWith('7800')) {
    return `+7 (800) ${val.slice(4, 7)}${val.length > 7 ? '-' : ''}${val.slice(
      7,
      9
    )}${val.length > 9 ? '-' : ''}${val.slice(9, 11)}`;
  }

  return `+7 (${val.slice(1, 4)}${val.length > 4 ? ') ' : ''}${val.slice(
    4,
    7
  )}${val.length > 7 ? '-' : ''}${val.slice(7, 9)}${
    val.length > 9 ? '-' : ''
  }${val.slice(9, 11)}`;
};

export default formatPhoneNumber;
